import { maycaApi } from "../helpers/api_helper";

export class CustomerRepository {
  endpoint = "/customer";

  async getCustomers(params) {
    const response = await maycaApi.get(`${this.endpoint}/paging-list`, {
      params,
    });
    return response.data;
  }
  async getCustomerById(id) {
    const response = await maycaApi.get(`${this.endpoint}/${id}`);
    return response.data;
  }
  async getSummaryByCustomer(id, params) {
    const response = await maycaApi.get(
      `${this.endpoint}/summary-mayca/${id}`,
      { params }
    );
    return response.data;
  }

  async getAutonomousSummaryByCustomer(id, params) {
    const response = await maycaApi.get(
      `${this.endpoint}/summary-mayca/autonomous/${id}`,
      { params }
    );
    return response.data;
  }

  async getPurchaseFrecuency(id, params) {
    const response = await maycaApi.get(
      `${this.endpoint}/purchase-frecuency/${id}`,
      { params }
    );
    return response.data;
  }

  async getInvoiceHistory(id, params) {
    const response = await maycaApi.get(
      `${this.endpoint}/invoice-history/${id}`,
      { params }
    );
    return response.data;
  }

  async getPrizeHistory(id, params) {
    const response = await maycaApi.get(
      `${this.endpoint}/prize-history/${id}`,
      { params }
    );
    return response.data;
  }

  async getProductsConsumed(id, params) {
    const response = await maycaApi.get(
      `${this.endpoint}/products-consumed/${id}`,
      { params }
    );
    return response.data;
  }

  async getReservedPoints(id, params) {
    const response = await maycaApi.get(
      `${this.endpoint}/reserved-points/${id}`,
      { params }
    );
    return response.data;
  }

  async postReservedPoints(id, payload) {
    const response = await maycaApi.post(
      `${this.endpoint}/assignment-points/${id}`,
      payload
    );
    return response.data;
  }

  async getInvoiceDetail(id) {
    const response = await maycaApi.get(
      `${this.endpoint}/invoice-detail/${id}`
    );
    return response.data;
  }
  async getPrizeDetail(id) {
    const response = await maycaApi.get(`${this.endpoint}/prize-detail/${id}`);
    return response.data;
  }

  async updateCustomerTypeHome(id, params) {
    const response = await maycaApi.patch(
      `${this.endpoint}/update-customer/home/${id}`,
      params
    );
    return response.data;
  }

  async updateCustomerTypeBusiness(id, params) {
    const response = await maycaApi.patch(
      `${this.endpoint}/update-customer/business/${id}`,
      params
    );
    return response.data;
  }

  async updateMaycaCodePersonalInfo(id, params) {
    const response = await maycaApi.patch(
      `${this.endpoint}/update/mayca-code/${id}`,
      params
    );
    return response;
  }

  async getClientsListExcel(params) {
    return await maycaApi.get(
      `${this.endpoint}/client-list/excel`,
      { params, responseType: "arraybuffer" }
    );
  }

  async handleBlockUser(id, params) {
    return await maycaApi.patch(
      `${this.endpoint}/block-user/${id}`,
      {},
      { params }
    )
  }

  async updateMaycaCodeEmail(id, params) {
    const response = await maycaApi.patch(
      `${this.endpoint}/update-email/${id}`,
      params
    );
    return response;
  }

  async addExtraPoints(data) {
    const response = await maycaApi.post(`${this.endpoint}/set-extra-points`, data);
    return response.data;
  }

  async getCustomersUserList(params) {
    const response = await maycaApi.get(`${this.endpoint}/customer-user-list`, {
      params,
    });
    return response.data;
  }

  async getRefundPointsByExpiredCerts(id, params) {
    const response = await maycaApi.get(`${this.endpoint}/refund-points-by-expired-certs/${id}`, {
      params,
    });
    return response.data;
  }


}
